import { useAvContext } from '@context/AvContextProvider';
import { HistoricalMode } from '@views/AccountManagement/types';

export const useIsIntuitiveHistoricalMode = () => useAvContext().accountData?.historicalMode === HistoricalMode.Intuitive;
